import { UcoastEl } from '@/scripts/core/UcoastEl';
import {getAttributeOrThrow, qsRequired} from "@/scripts/core/global";

type LegacyAPIGiftCard = {
    balance: string
    created_at: string
    expires_on: string | null
    initial_value: string
    last_characters: string
    note: string
}
export class GiftCardData extends UcoastEl {
    static htmlSelector = 'gift-card-data'
    emptyContent: HTMLElement
    grid: HTMLElement
    starterEl: HTMLElement
    customerId: string
    constructor() {
        super()
        this.customerId = getAttributeOrThrow('data-uc-customer-id', this)
        this.emptyContent = qsRequired('[data-uc-empty-content]', this)
        this.grid = qsRequired('[data-uc-grid]', this)
        this.starterEl = qsRequired('[data-uc-starter]', this)
        void this.loader()
    }

    async loader() {
        const url = `https://data.aromatics.com/customer/${this.customerId}/giftcard`
        const giftCards: LegacyAPIGiftCard[] = await fetch(
            url
        ).then((response) => response.json()).catch(e => {
            console.log('no gift cards found', e)
        })
        if (!giftCards.length) {
            this.grid.style.display = 'none'
            return
        }
        this.emptyContent.style.display = 'none'
        giftCards.forEach((giftCard) => {
            const newEl = this.buildStarterEl(giftCard)
            this.grid.appendChild(newEl)
            this.starterEl.remove()
        })
    }

    buildStarterEl(data: LegacyAPIGiftCard) {
        const newEl = this.starterEl.cloneNode(true) as HTMLElement
        const balance = qsRequired('[data-uc-balance]', newEl)
        const createdAt = qsRequired('[data-uc-created-at]', newEl)
        const initialValue = qsRequired('[data-uc-initial-value]', newEl)
        const note = qsRequired('[data-uc-note]', newEl)
        const expiresOn = qsRequired('[data-uc-expires-on]', newEl)
        const lastCharacters = qsRequired('[data-uc-last-characters]', newEl)

        balance.textContent = data.balance
        createdAt.textContent = data.created_at
        initialValue.textContent = data.initial_value


        if (data.expires_on) {
            expiresOn.textContent = data.expires_on
        } else {
            const expiresOnContainer = qsRequired('[data-uc-expires-on-container]', newEl)
            expiresOnContainer.remove()
        }
        if (data.note && data.note !== '' && data.note !== ' ' && data.note.length > 4) {

            note.textContent = data.note
        } else {
            const noteContainer = qsRequired('[data-uc-note-container]', newEl)
            noteContainer.remove()
        }
        lastCharacters.textContent = data.last_characters
        return newEl
    }
    override connectedCallback() {
        super.connectedCallback();
    }
}
